import { POST } from "../APiHelper/API";

export const transferSquadAndGameDataApi = (from_fixture_id, to_fixture_id, onSuccess, onError) => {
    const data = {
        from_fixture_id: from_fixture_id,
        to_fixture_id: to_fixture_id
    }
    POST(`/api/v1/squads/transfer_squad_and_game_data`, data, onSuccess, onError)
}